package org.hs_soft.runmynesto.domain.usecase.login

import org.hs_soft.runmynesto.domain.repository.network_datasource.login.ResetPasswordRepository


class ResetPasswordUseCase(
    private val repository: ResetPasswordRepository
) {
    suspend operator fun invoke(
        newPassword:String,
        userName:String,
        verifyCode:String,
        onSuccess:()->Unit,
        onError:(String)->Unit,
    ) {
        repository.resetPassword(
            newPassword =newPassword ,
            userName=userName,
            verificationCode = verifyCode,
            onSuccess = {
                onSuccess()
            },
            onError={
                onError(it)
            }

        )
    }
}